/**
 * Returns true if all elements of "target" exist in "arr"
 */
export const isArraySubset = <T>(arr: T[], target: T[]): boolean =>
  target.every(v => arr.includes(v));
